import axios from 'axios';
import {checkTokenValidity} from '../utils/checkTokenValidity';
import Cookies from 'js-cookie';

const axiosPrivateInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {'Content-Type': 'multipart/form-data'},
});

//Request Interceptor
axiosPrivateInstance.interceptors.request.use(config => {
    checkTokenValidity();
    config.headers['Authorization'] = 'Bearer ' + Cookies.get('access');
    config.headers['Content-Type'] = 'multipart/form-data';
    config.withCredentials = true;
    return config;
});

// Response Interceptor
axiosPrivateInstance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        const request = error.config; //this is actual request that was sent, and error is received in response to that request
        if (error.response?.status === 401 && !request._retry) {
            request._retry = true;
            axios.defaults.headers.common['Authorization'] =
                'Bearer ' + Cookies.get('access');
            axios.defaults.headers.common['Content-Type'] =
                'multipart/form-data';
            return axios(request);
        }
        return Promise.reject(error);
    }
);

export default axiosPrivateInstance;
